import { AbstractGameService } from '../../../core/abstractions/AbstractGameService';
import {
  getSpinUrl,
  getBonusSpinUrl,
  getPreBonusSpinUrl,
  getBuyBonusUrl,
} from '../../../core/endpoints';
import { httpClient } from '../../../core/httpClient';
import { partnerService } from '../../helperServices/PartnerService';
import { ACTIVE_ODD, BONUS_TICKET_TYPE, PRE_BONUS_ID } from '../../../stateManagment';
import { gamePadService } from '../../helperServices/GamePadService';
import { historyHelperService } from '../../helperServices/HistoryHelperService';
import { GameMode } from '../../../core/enums';
import { BONUS_COST_MULTIPLIER } from '../../../core/constats';
import { gameService } from '../GameService';

export class BaseGameStrategy extends AbstractGameService {

  async spin(body) {
    const data = { ...this._createSpinBody(), ...body };
    const { amount } = data;
    return await httpClient.post(getSpinUrl({ isDemo: false }), data).then(res => {
      historyHelperService.add({
        time: new Date().toISOString(),
        betAmount: amount,
        result: res.result,
        winAmount: res.winAmount,
        odd: res.odd,
        bonus: gameService.isBonus(),
      });
      return res;
    });
  }

  async bonusSpin(body) {
    return await httpClient.post(getBonusSpinUrl({ isDemo: true }), body);
  }

  async preBonusSpin(body) {
    return await httpClient.post(getPreBonusSpinUrl({ isDemo: true }), body);
  }

  async buyBonus(body) {
    return await httpClient.post(getBuyBonusUrl({ isDemo: true }), body);
  }

  _createSpinBody() {
    return {
      partnerId: partnerService.partnerId,
      amount: gamePadService.quickBet,
      ball: ACTIVE_ODD.getValue(),
      currencyCode: partnerService.currency,
    };
  }

  _createBonusSpinBody() {
    return {
      bonusId: PRE_BONUS_ID.getValue(),
      bonusType: BONUS_TICKET_TYPE.getValue(),
    };
  }

  _createBuyBonusBody() {
    return {
      partnerId: partnerService.partnerId,
      amount: gamePadService.quickBet * BONUS_COST_MULTIPLIER,
      currencyCode: partnerService.currency,
      buyBonusData: null,
    };
  }

  _createInitialStateParams() {
    if (this._mode === GameMode.demo) {
      return {
        partnerId: partnerService.partnerId,
        isDemo: true,
      };
    }
    return {
      partnerId: partnerService.partnerId,
      isDemo: false,
    };
  }
}
